import React, { Component } from 'react';
import { Grid, Typography, Button, MuiThemeProvider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import Fade from 'react-reveal/Bounce';
import {v4 as uuidv4} from 'uuid';

import DisplayGameObject from '../components/DisplayGameObject';
import { isSmallScreen } from '../components/Utils';

let interval = null;

class EndGame extends Component {
    constructor(props) {
        super(props);
        this.groupProps = {
          appear: false,
          enter: true,
          exit: true
        };
        this.state = {
          gameObjectIndex: 0,
          gameObjSubIndex: 0,
          displayObjectArray: [],
          showNewGameButton: false
        };
        
        this.update = this.update.bind(this);
    }

    componentDidMount() {
        interval = setInterval(() => {
            this.update();
        }, 5000);
    };

    componentDidUpdate = () => {
        this.scrollToBottom();
    };

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    };

    update = () => {
        if (this.state.gameObjectIndex >= this.props.gameObjects.length) {
          this.setState({ showNewGameButton: true });
          clearInterval(interval);
          this.props.sendGameObjectsToPlayers();
          return;
        }
    
        let gameObject = this.props.gameObjects[this.state.gameObjectIndex];
    
        if (this.state.gameObjSubIndex >= gameObject.submissions.length) {
          // Move to next game object, set sub index to 0
          this.setState({
            gameObjectIndex: this.state.gameObjectIndex + 1,
            gameObjSubIndex: 0,
            displayObjectArray: []
          });
          return;
        }
    
        if (this.state.displayObjectArray.length > 1) {
            // If more than one, drop the first index of array
            this.setState({
                displayObjectArray: [
                    ..._.drop(this.state.displayObjectArray),
                    gameObject.submissions[this.state.gameObjSubIndex]
                ],
                gameObjSubIndex: this.state.gameObjSubIndex + 1
            });
        }
        else
        {
            // Add new submission to displayObjectArray
            this.setState({
                displayObjectArray: [
                ...this.state.displayObjectArray,
                gameObject.submissions[this.state.gameObjSubIndex]
                ],
                gameObjSubIndex: this.state.gameObjSubIndex + 1
            });
        }
    };

    render() {
        const { players, theme } = this.props;
        const { displayObjectArray, gameObjSubIndex } = this.state;

        return (
            <MuiThemeProvider theme={theme}>
                <Grid container style={{ textAlign: 'center', margin: 'auto'}}>
                    <Typography variant='h4' color='secondary' style={{width: '100%', marginBottom: 15}}>Results</Typography>
                    {displayObjectArray.map(item => (
                        item === displayObjectArray[0] && displayObjectArray.length > 1 ?
                            <Grid key={uuidv4()} container item xs={12}>
                                <Grid item xs={12}>
                                    <Typography 
                                        variant='h6' 
                                        style={{display: 'block', backgroundColor: _.find(players, {id: item.playerId}) ? _.find(players, {id: item.playerId}).color : 'lightgreen', borderRadius: 5}}
                                    >
                                        { _.find(players, {id: item.playerId }) ?  _.find(players, {id: item.playerId}).name : "Name" }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant='h5' color='secondary'>
                                        {item.type === 'draw' ?
                                            "Drew..."
                                        :
                                            "Wrote..."
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <DisplayGameObject
                                        theme={theme}
                                        lastRoundData={item}
                                    />
                                </Grid>
                                <hr style={{width: "80vw"}} />
                            </Grid>
                        :
                        <Fade key={uuidv4()} collapse bottom>
                            <Grid container item xs={12}>
                                <Grid item xs={12}>
                                    <Typography 
                                        variant='h6' 
                                        style={{display: 'block', backgroundColor: _.find(players, {id: item.playerId}) ? _.find(players, {id: item.playerId}).color : 'lightgreen', borderRadius: 5}}
                                    >
                                        { _.find(players, {id: item.playerId }) ?  _.find(players, {id: item.playerId}).name : "Name" }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant='h5' color='secondary'>
                                        {item.type === 'draw' ?
                                            "Drew..."
                                        :
                                            "Wrote..."
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <DisplayGameObject
                                        theme={theme}
                                        lastRoundData={item}
                                    />
                                </Grid>
                                <hr style={{width: "80vw"}} />
                            </Grid>
                        </Fade>
                    ))}
                    { this.state.showNewGameButton &&
                        <Grid container>
                            <Grid item xs={12} style={{textAlign: 'center'}}>
                                <Fade top>
                                    <Typography variant='h4' color='secondary'>Start a new game?</Typography>
                                </Fade>
                                <Fade bottom>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ float: "right", marginTop: 10 }}
                                        onClick={this.props.startNewGame}
                                        fullWidth={isSmallScreen()}
                                    >
                                        New Game
                                    </Button>
                                </Fade>
                            </Grid>
                        </Grid>
                    }
                    <div style={{ float:"left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </Grid>
            </MuiThemeProvider>
        );
    };
};

const styles = theme => ({ });
  
export default withStyles(styles)(EndGame);